import {i18n} from '@js/i18n'

export const RECORDS_VERBOSE = Object.freeze({
  issuance: i18n.tx_issuance(),
  investment: i18n.tx_investment(),
  match: i18n.tx_match(),
  withdrawal: i18n.tx_withdrawal(),
  transfer: i18n.tx_transfer(),
  offer: i18n.tx_offer(),
  invoice: i18n.tx_invoice()
})

export const DIRECTION_VERBOSE = Object.freeze({
  in: 'in',
  out: 'out'
})



// WEBPACK FOOTER //
// ./src/js/records/help/records.const.js